module.exports = __webpack_public_path__ + "static/media/ied-logo.bf731cfa.jpg";